/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  Condition,
  ErrorResponse,
  Sorting,
  StoreResponseCollectionResponse,
  YPickStoreCredentialsResponseCollectionResponse,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';
export class Stores<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags Stores
   * @name GetStores
   * @request GET:/Stores
   * @response `200` `StoreResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getStores = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<StoreResponseCollectionResponse, ErrorResponse>({
      path: `/Stores`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Stores
   * @name GetStoresYPickCredentials
   * @summary List of available credentials for stores and departments
   * @request GET:/Stores/YPickCredentials
   * @response `200` `YPickStoreCredentialsResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getStoresYPickCredentials = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<YPickStoreCredentialsResponseCollectionResponse, ErrorResponse>({
      path: `/Stores/YPickCredentials`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Stores
   * @name GetStoreYPickLoginQrCode
   * @summary Retrieves a QR Code login image for given store as image/png content type. The QR Code can then be scanned by the Y'pick Android application to log in to the system as given store.
   * @request GET:/Stores/{id}/YPickLoginQrCode
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getStoreYPickLoginQrCode = (id: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Stores/${id}/YPickLoginQrCode`,
      method: 'GET',
      ...params,
    });
  /**
   * No description
   *
   * @tags Stores
   * @name GetAllYPickLoginQrCodes
   * @request GET:/Stores/YPickLoginCredentials.zip
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getAllYPickLoginQrCodes = (params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/Stores/YPickLoginCredentials.zip`,
      method: 'GET',
      ...params,
    });
}
